import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="max-w-6xl mx-auto px-5 pt-14" data-testid="about-page">
      <p className="font-college text-lg text-red">PERSISTENCE &amp; LONGEVITY</p>
      <h1 className="font-college text-4xl sm:text-5xl text-navy mt-2 max-w-2xl leading-[1.1]" data-testid="about-heading">
        KEEP SHOWING UP. BUILD SOMETHING THAT LASTS.
      </h1>

      <div className="grid gap-12 lg:grid-cols-12 mt-14 items-start">
        <div className="lg:col-span-7 space-y-6 text-base md:text-lg text-ink/75 leading-relaxed max-w-xl">
          <p data-testid="about-p1">
            RUNRS is not built around one type of athlete, because it isn't really about
            athletics. It's for people who want more movement, more community, or simply
            more reasons to get outside.
          </p>
          <p data-testid="about-p2">
            A walk counts. A slow ride counts. Skating, pushing a stroller, showing up to
            watch and eat the food — all of it counts. The point was never performance.
            The point is that you keep going, and that something is still there next week.
          </p>
          <p data-testid="about-p3">
            Persistence is the practice. Longevity is the goal.
          </p>
        </div>
        <div className="lg:col-span-5 relative">
          <img
            src="/assets/runrs-world.png"
            alt="RUNRS world graphic — letterman mascot leaning on an R in front of a globe"
            data-testid="about-note-image"
            className="w-full max-w-sm mx-auto -mt-8 lg:-mt-16"
          />
        </div>
      </div>

      <div className="grid gap-10 md:gap-14 md:grid-cols-2 mt-16 items-start" data-testid="about-deck-notes">
        <img
          src="/assets/whatweare_note.png"
          alt="WHAT WE ARE — torn notebook page from the RUNRS deck"
          data-testid="about-whatweare-note"
          className="w-full -rotate-1 [filter:drop-shadow(0_8px_18px_rgba(17,17,17,0.16))]"
        />
        <img
          src="/assets/coreidea_note.png"
          alt="CORE IDEA — torn notebook page from the RUNRS deck"
          data-testid="about-coreidea-note"
          className="w-full rotate-1 md:mt-10 [filter:drop-shadow(0_8px_18px_rgba(17,17,17,0.16))]"
        />
      </div>

      <div className="mt-16 pb-4 flex flex-wrap gap-4">
        <Link
          to="/show-up"
          data-testid="about-showup-cta"
          className="bg-navy text-paper font-college text-xl px-6 py-3 shadow-print hover:bg-red transition-colors"
        >
          SHOW UP
        </Link>
        <Link
          to="/shop"
          data-testid="about-shop-cta"
          className="bg-paper text-ink font-college text-xl px-6 py-3 shadow-print hover:bg-yellow transition-colors"
        >
          SEE THE PIECES
        </Link>
      </div>
    </div>
  );
}
